import {
  loginResponseSchema,
  meResponseSchema,
  type LoginRequest,
  type LoginResponse,
  type MeResponse,
} from "@shared/schemas/auth";
import { apiGet, apiPost, noContentSchema } from "@client/lib/api";

/** The three auth calls, in one place. See docs/06-api.md#auth. */

export const fetchMe = (): Promise<MeResponse> => apiGet("/auth/me", meResponseSchema);

export const postLogin = (credentials: LoginRequest): Promise<LoginResponse> =>
  apiPost("/auth/login", loginResponseSchema, credentials);

export const postLogout = (): Promise<undefined> => apiPost("/auth/logout", noContentSchema);
